/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../../common/time';
import '../../../models/transfer';
import '../../../models/transaction';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "ListTransactionsRequest": {
                    "fields": {
                      "accountId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "pageSize": {
                        "type": "uint32",
                        "id": 2,
                        "rule": "optional"
                      },
                      "pageNumber": {
                        "type": "uint32",
                        "id": 3,
                        "rule": "optional"
                      },
                      "beginDate": {
                        "type": ".squareup.common.time.YearMonthDay",
                        "id": 4,
                        "rule": "optional"
                      },
                      "endDate": {
                        "type": ".squareup.common.time.YearMonthDay",
                        "id": 5,
                        "rule": "optional"
                      },
                      "savingsTransferType": {
                        "type": ".squareup.sfs.models.TransferType",
                        "id": 6,
                        "rule": "optional"
                      }
                    }
                  },
                  "ListTransactionsResponse": {
                    "fields": {
                      "transactions": {
                        "type": ".squareup.sfs.models.Transaction",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "hasMoreResults": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 3,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.ListTransactionsRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.ListTransactionsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListTransactionsRequest @ squareup/sfs/external/services/transfer/list_transactions.proto at 11:1
 */
export const ListTransactionsRequest = $root.lookupType('squareup.sfs.external.service.ListTransactionsRequest');
fixType(ListTransactionsRequest, {
  accountId: {
    required: true
  }
});
Builder.createAndAttachToType(ListTransactionsRequest);
/**
 * SOURCE ListTransactionsResponse @ squareup/sfs/external/services/transfer/list_transactions.proto at 43:1
 */
export const ListTransactionsResponse = $root.lookupType('squareup.sfs.external.service.ListTransactionsResponse');
fixType(ListTransactionsResponse);
Builder.createAndAttachToType(ListTransactionsResponse);